import { render, staticRenderFns } from "./ProfileEditPage.vue?vue&type=template&id=3dd45e11&scoped=true&"
import script from "./ProfileEditPage.vue?vue&type=script&lang=js&"
export * from "./ProfileEditPage.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEditPage.vue?vue&type=style&index=0&id=3dd45e11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd45e11",
  null
  
)

export default component.exports